(function () {
  'use strict';

  if (customElements.get('cart-promo-progress')) return;

  function formatMoney(amount, moneyFormat) {
    var value = Number(amount) || 0;
    var formatted = value.toFixed(2);
    if (!moneyFormat) return '$' + formatted;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(Math.round(value * 100), moneyFormat);
      }
    } catch (e) {}
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(value)));
  }

  function t(i18n, key, params) {
    var template = (i18n && i18n[key]) || key;
    if (!params) return template;
    return template.replace(/\[\[(\w+)\]\]|\{\{\s*(\w+)\s*\}\}/g, function (_, a, b) {
      var name = a || b;
      return params[name] != null ? String(params[name]) : '';
    });
  }

  function ticketIcon() {
    return (
      '<svg class="cart-promo-top__ticket" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M1.5 4.5A1.5 1.5 0 0 1 3 3h10a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 0 0 3v1A1.5 1.5 0 0 1 13 11H3A1.5 1.5 0 0 1 1.5 9.5v-1a1.5 1.5 0 0 0 0-3v-1z"/>' +
      '</svg>'
    );
  }

  class CartPromoProgress extends HTMLElement {
    connectedCallback() {
      this._render();
      this._markFreeLines();
    }

    _payload() {
      var el = this.querySelector('[data-cart-promo-payload]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.error('[cart-promo] invalid payload', e);
        return null;
      }
    }

    _scopeRoot() {
      return (
        this.closest('cart-items, cart-drawer-items, .drawer__cart-items-wrapper, form') ||
        this.parentElement ||
        document
      );
    }

    _render() {
      var payload = this._payload();
      if (!payload || !window.GeekoCartPromoEngine) return;

      var view = window.GeekoCartPromoEngine.compute(
        { orderAmount: payload.orderAmount, lines: payload.lines || [] },
        payload.config || {}
      );
      this._view = view;
      this._i18n = payload.i18n || {};
      this._moneyFormat = payload.moneyFormat || '${{amount}}';
      this._addUrl = payload.addUrl || '/collections/all-products';
      this._payloadData = payload;

      var top = this.querySelector('[data-cart-promo-top]');
      var topHtml = this._topHtml(view);
      if (top) top.innerHTML = topHtml;

      this._groupItemsWithBanners(view, payload);

      this.dataset.winner = view.winner;
      var hasGroupBanner = (view.groups || []).some(function (g) {
        return g.visible;
      });
      this.hidden = !(topHtml || hasGroupBanner);
    }

    _money(amount) {
      return formatMoney(amount, this._moneyFormat);
    }

    _topHtml(view) {
      var parts = [];
      // Free-shipping success UI is owned by the existing cart plugin; do not duplicate it here.

      var bar = view.thresholdBar;
      if (bar.visible) {
        var msg = '';
        if (bar.mode === 'to_t1') {
          msg = t(this._i18n, 'threshold_to_t1', {
            remain: this._money(bar.remain),
            off: bar.nextOff,
          });
        } else if (bar.mode === 'unlocked_t1') {
          msg = t(this._i18n, 'threshold_unlocked_t1', {
            unlocked: bar.unlockedOff,
            remain: this._money(bar.remain),
            off: bar.nextOff,
          });
        } else {
          msg = t(this._i18n, 'threshold_unlocked_t2', { unlocked: bar.unlockedOff });
        }

        parts.push(
          '<div class="cart-promo-top__threshold">' +
            '<div class="cart-promo-top__threshold-row">' +
            ticketIcon() +
            '<p class="cart-promo-top__threshold-text">' +
            msg +
            '</p>' +
            (bar.showAdd
              ? '<a class="cart-promo-top__add" href="' +
                this._addUrl +
                '">' +
                t(this._i18n, 'add_cta') +
                '</a>'
              : '') +
            '</div>' +
            '<div class="cart-promo-top__threshold-bar" aria-hidden="true"><span style="width:' +
            Math.round(bar.progress * 100) +
            '%"></span></div>' +
            '</div>'
        );
      }

      return parts.join('');
    }

    _bannerHtml(g, payload) {
      var urls = (payload && payload.groupUrls) || {};
      var href = urls[g.id] || this._addUrl;
      var msg = t(this._i18n, g.messageKey, g.messageParams);
      var title = g.title;
      if (payload.groupTitles && payload.groupTitles[g.id]) title = payload.groupTitles[g.id];

      return (
        '<div class="cart-promo-group cart-promo-group--' +
        g.banner +
        '" data-promo-group="' +
        g.id +
        '">' +
        '<div class="cart-promo-group__copy">' +
        '<p class="cart-promo-group__title">' +
        title +
        '</p>' +
        '<p class="cart-promo-group__msg">' +
        msg +
        '</p>' +
        '</div>' +
        (g.showAdd
          ? '<a class="cart-promo-group__add cart-buy3-banner__add" href="' + href + '">+Add</a>'
          : '') +
        '</div>'
      );
    }

    _groupItemsWithBanners(view, payload) {
      var root = this._scopeRoot();
      var tables = root.querySelectorAll('table.cart-items');
      if (!tables.length) return;

      var order = ['b3g1', 'multi', 'normal'];

      tables.forEach(function (table) {
        var tbody = table.tBodies[0] || table.querySelector('tbody');
        if (!tbody) return;

        tbody.querySelectorAll('tr[data-cart-promo-group-row]').forEach(function (row) {
          row.remove();
        });

        var hasPromoGroups = !!(
          tbody.querySelector('tr.cart-item[data-cart-promo-group="b3g1"]') ||
          tbody.querySelector('tr.cart-item[data-cart-promo-group="multi"]')
        );

        var frag = document.createDocumentFragment();
        order.forEach(function (gid) {
          var rows = Array.prototype.slice.call(
            tbody.querySelectorAll('tr.cart-item[data-cart-promo-group="' + gid + '"]')
          );
          if (!rows.length) return;

          if (gid === 'normal') {
            if (hasPromoGroups) {
              var itemsHeader = document.createElement('tr');
              itemsHeader.setAttribute('data-cart-promo-group-row', 'normal');
              itemsHeader.className = 'cart-promo-items-heading-row';
              var itemsTd = document.createElement('td');
              itemsTd.colSpan = Math.max(rows[0].cells.length, 1);
              itemsTd.innerHTML = '<p class="cart-promo-items-heading">Items</p>';
              itemsHeader.appendChild(itemsTd);
              frag.appendChild(itemsHeader);
            }
          } else {
            var g = (view.groups || []).find(function (x) {
              return x.id === gid;
            });
            if (g && g.visible) {
              var bannerRow = document.createElement('tr');
              bannerRow.setAttribute('data-cart-promo-group-row', gid);
              bannerRow.className = 'cart-promo-group-row';
              var td = document.createElement('td');
              td.colSpan = Math.max(rows[0].cells.length, 1);
              td.innerHTML = this._bannerHtml(g, payload);
              bannerRow.appendChild(td);
              frag.appendChild(bannerRow);
            }
          }

          rows.forEach(function (row) {
            frag.appendChild(row);
          });
        }, this);

        tbody.appendChild(frag);
      }, this);
    }

    _markFreeLines() {
      var root = this._scopeRoot();
      root.querySelectorAll('[data-cart-promo-free]').forEach(function (el) {
        el.hidden = true;
      });
      root.querySelectorAll('[data-cart-line-key]').forEach(function (row) {
        row.classList.remove('cart-item--promo-free');
      });

      if (!this._view || !this._view.freeLineKeys || !this._view.freeLineKeys.length) return;
      var keys = this._view.freeLineKeys;
      keys.forEach(function (key) {
        var safe = String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        var row = root.querySelector('[data-cart-line-key="' + safe + '"]');
        if (!row) return;
        row.classList.add('cart-item--promo-free');
        var freeLabel = row.querySelector('[data-cart-promo-free]');
        var priceWrap = row.querySelector('[data-cart-promo-price]');
        if (priceWrap) priceWrap.hidden = false;
        if (freeLabel) {
          freeLabel.hidden = false;
          if (priceWrap && freeLabel.parentElement !== priceWrap) {
            priceWrap.insertBefore(freeLabel, priceWrap.firstChild);
          }
        }
      });
    }
  }

  customElements.define('cart-promo-progress', CartPromoProgress);
})();
